// Ballot Status
export const BALLOT_CLOSE = 'Closed';
export const BALLOT_STATUS_OPEN = "Open";
export const BALLOT_STATUS_OUT_FOR_BALLOT = "Out for Ballot"; 
export const BALLOT_OPEN = 'Ready for voting';
export const BALLOT_DISPOSITION = 'BallotDisposition';
export const BALLOT_DISPOSITION_DISPLAYNAME = 'Ballot Disposition';
export const BALLOT_OUT_FOR_BALLOT = 'Active';
export const BALLOT_DRAFT = 'Draft';
export const BALLOT_CANCELLED = 'Cancelled';
export const BALLOT_CLOSED = 'Closed';
export const BALLOT_RECORD_CLOSE = 'Closed';
export const BALLOT_RECORD_OPEN = 'Open';
export const BALLOT_RECORD_OUT_FOR_BALLOT = 'Out for ballot';
export const BALLOT_RECORD_OUT_FOR_BALLOT_CLOSE = 'Out for Ballot';
export const BALLOT_RECORD_DRAFT = 'Draft';
export const MEMBERSHIP_PROFILE_KEY = 'loggedinuserprofileid';
export const EXCLUDE_SECRET_BALLOT_KEY = "userProfileIdToExcludeSecretBallot"
export const BALLOT_STATUS_KEY = "ballotstatusid";
export const BALLOT_RECIRCULATION = "Recirculation";
export const BALLOT_REVIEW_AND_COMMENT = 'Review and Comments';
export const GUID_PlACEHOLDER = "00000000-0000-0000-0000-000000000000";
export const RECORD_REOPEN = "Reopen";
export const RECORD_APPROVED_PENDING_MEMBERSHIP = "Approved - Pending Grant Membership";
export const RECORD_APPROVED = "Approved";
export const RECORD_REJECTED = "Rejected";
export const DISAPPROVED_LABEL = "Disapproved";
export const CURRENT_MEMBERSHIP = "Current";
export const DEFAULT_BALLOT_TYPE = "Normal Ballot";
export const DEFAULT_BALLOT_SUB_TYPE = "First Consideration";
export const DEFAULT_BALLOT_LEVEL = "Standard";
export const RECORD_TYPE = "Membership";
export const RECORD_TYPE_STANDARD = "Standard";
export const RECORD_TYPE_ADMINISTRATIVE = "Administrative";
export const RECORD_TYPE_NONSTANDARD = "NonStandardDocument";
export const RECORD_SUB_TYPE = "New Membership";
export const RECORD_SUB_TYPE_STANDARD = "New Standard";
export const RECORD_SUB_TYPE_ADMINISTRATIVE = "Terms of Reference";
export const RECORD_SUB_TYPE_ADMINISTRATIVE_VALUE = "TermsOfReference";
export const RECORD_SUB_TYPE_NONSTANDARD = "Handbooks";
export const TAB_ALL = "All";
export const RECORD_SUB_TYPEID = "recordsubtypeid"; // to pass in query param
export const RECORD_TYPEID = "recordtypeid";
export const RECORD_SUB_TYPE_OPTIONS = ["New Membership", "Reappointment"];
export const RECORD_SUB_TYPE_ASMINISTRATION_OPTION = ["Terms of Reference"];
export const RECORD_SUB_TYPE_NONSTANDARD_OPTION = ["Handbooks", "Commentary", "Guideline", "TechnicalSpecification", "WorkshopAgreement", "PrivateStandard" ];
export const RECORD_READY_FOR_BALLOT = "Ready for ballot";
export const RECORD_SUB_TYPE_OPTIONS_STANDARD = ["New Standard", "NewEdition", "NewAmendment", "Reaffirmation", "Interpretation", "Supplement", "Withdrawal"];
export const BALLOT_DISPOSITION_DISPLAY_NAME = "Ballot disposition";
export const IS_ALL_COMMITTEE_BALLOT = "IsAllCommitteSelected";
export const COMMENT_AP_S_PERSUASIVE = "Persuasive";
export const COMMENT_AP_S_PERSUASIVE_FUTURE_WORK = "Persuasive for future work";
export const COMMENT_AP_S_NON_PERSUASIVE = "Non-Persuasive";
export const COMMENT_AP_S_NON_GERMANE = "Non-Germane";
export const COMMENT_AP_S_EDITORIAL = "Editorial";
export const COMMENT_APPROVAL_STATUS = ["Disapproved without comment", "Unrelated to proposal", COMMENT_AP_S_PERSUASIVE, COMMENT_AP_S_PERSUASIVE_FUTURE_WORK, COMMENT_AP_S_NON_PERSUASIVE, COMMENT_AP_S_NON_GERMANE, COMMENT_AP_S_EDITORIAL];
export const STANDARD_RECORD_READY_FOR_BALLOT = "Ready for Ballot";
export const STANDARD_RECORD_OPEN = "Open";
export const STANDARD_ACC_BODY_VOTE = "SCC";
export const STANDARD_ACC_BODY_VOTE_EDIT = ["ANSI", "ANSI and SCC"];
export const RECORD_STANDARD_RECIRCULATION_REOPEN = "Re-Open";
export const BALLOT_ISSUE_EMAIL = "BallotInitiated";
export const NEGATIVE_WITH_COMMENT_LABEL = "Negative with comment";
export const NO_SURE_COMMENT_LABEL = "No I do not agree";
export const APPROVED_LABEL = "Approved";
export const AFFIRMATIVE_LABEL = "Affirmative";
export const YESIAGREE = "Yes, I agree";
export const ABSTAIN_LABEL = "Abstain";
